module.exports = __webpack_public_path__ + "static/images/icomoon.ae3ad39.svg";